export enum EHeroGender {
  ALL = 'ALL',
  WOMEN = 'WOMEN',
  MEN = 'MEN',
}
